import type { SelectItemType } from "@/components/ui/select"
import type { Tag } from "@/types"

/**
 * Map tags to the shape the MultiSelect tag picker expects.
 * @param tags - The tags to map.
 * @returns The tags as select items (id is stringified for react-aria keys).
 */
export function mapTagSelectionFormItem(tags: Tag[]): SelectItemType[] {
  return tags.map((tag) => ({
    id: String(tag.id),
    label: tag.name,
  }))
}
